import React from 'react';
import { PRODUCTION_CLIENTS, BRAND_CLIENTS } from '../mock';

function LogoRow({ items, reverse = false, variant = 'production' }) {
  const doubled = [...items, ...items];
  return (
    <div className="edge-fade pause-on-hover overflow-hidden">
      <div className={`flex gap-4 md:gap-5 w-max ${reverse ? 'animate-marquee-slow' : 'animate-marquee'}`} style={reverse ? { animationDirection: 'reverse' } : {}}>
        {doubled.map((c, i) => (
          <div
            key={i}
            className={`shrink-0 h-28 md:h-32 w-48 md:w-56 rounded-2xl border flex flex-col items-center justify-center px-5 transition-all duration-500 group ${
              variant === 'production'
                ? 'bg-[#162028] border-[#162028] text-[#ede2c4] hover:bg-[#49001B] hover:border-[#49001B]'
                : 'bg-[#ede2c4] border-[#162028]/12 text-[#162028] hover:bg-[#49001B] hover:border-[#49001B] hover:text-[#ede2c4]'
            }`}
          >
            <div className="font-serif-display text-[22px] md:text-[26px] leading-none tracking-tight text-center">{c.name}<span className={variant === 'production' ? 'text-[#ddc390]' : 'text-[#49001B] group-hover:text-[#ddc390]'}>.</span></div>
            <div className={`mt-2 text-[10px] uppercase tracking-[0.24em] ${variant === 'production' ? 'text-[#ddc390]/70' : 'text-[#162028]/50 group-hover:text-[#ede2c4]/70'}`}>{c.tag}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Clients() {
  return (
    <section className="relative py-20 md:py-28 bg-[#ddc390]">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 mb-12">
        <div className="flex items-end justify-between flex-wrap gap-6">
          <div>
            <div className="text-[12px] uppercase tracking-[0.22em] text-[#162028]/70 mb-4 flex items-center gap-2">
              <span className="h-px w-8 bg-[#49001B]" /> Our Clients
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1] tracking-tight text-[#162028] max-w-3xl">
              Trusted by <span className="italic text-[#49001B]">production houses</span> &amp; brands.
            </h2>
          </div>
          <p className="text-[15px] leading-relaxed text-[#162028]/75 max-w-sm">From marquee movie launches to homegrown consumer brands — our partners span cinema, retail, wellness and hospitality.</p>
        </div>
      </div>

      <div className="space-y-8">
        <div>
          <div className="mx-auto max-w-[1400px] px-5 md:px-10 mb-4">
            <div className="text-[11px] uppercase tracking-[0.24em] text-[#162028]/55">Production Houses</div>
          </div>
          <LogoRow items={PRODUCTION_CLIENTS} variant="production" />
        </div>
        <div>
          <div className="mx-auto max-w-[1400px] px-5 md:px-10 mb-4">
            <div className="text-[11px] uppercase tracking-[0.24em] text-[#162028]/55">Brands</div>
          </div>
          <LogoRow items={BRAND_CLIENTS} variant="brand" reverse />
        </div>
      </div>
    </section>
  );
}
